export type BusinessModuleKey =
  | 'warehouse_3pl'
  | 'transit_consolidation'
  | 'courier_logistics'
  | 'procurement_distribution';

export interface BusinessModuleDef {
  key: BusinessModuleKey;
  label: string;
  description: string;
  ready: boolean;
}

export const ACTIVE_BUSINESS_MODULE_KEY = 'active_business_module';

export const BUSINESS_MODULES: BusinessModuleDef[] = [
  {
    key: 'warehouse_3pl',
    label: '海外仓/仓配托管',
    description: '已接入当前系统功能，可直接进入业务后台。',
    ready: true,
  },
  {
    key: 'transit_consolidation',
    label: '包裹转运集运',
    description: '功能开发中，当前进入占位页。',
    ready: false,
  },
  {
    key: 'courier_logistics',
    label: '快递物流',
    description: '功能开发中，当前进入占位页。',
    ready: false,
  },
  {
    key: 'procurement_distribution',
    label: '商品采购/分销代理',
    description: '功能开发中，当前进入占位页。',
    ready: false,
  },
];

export const MODULE_KEY_TO_LABEL: Record<BusinessModuleKey, string> = {
  warehouse_3pl: '海外仓/仓配托管',
  transit_consolidation: '包裹转运集运',
  courier_logistics: '快递物流',
  procurement_distribution: '商品采购/分销代理',
};

export const DEFAULT_MODULE_KEY: BusinessModuleKey = 'warehouse_3pl';

export const getModulePlaceholderPath = (key: BusinessModuleKey): string =>
  `/dashboard/module/${key}`;

